import { publicRequest } from "@/store/api";

export const signUpByLocation = async values => {
  const res = await publicRequest.post("/home/signUpByLocation", values);
  return res?.data;
};

export const getNearestGrosByLocation = async (
  id,
  latitude,
  longitude,
  isFromGoogle = false
) => {
  const res = await publicRequest.post("/home/getUserByLocation", null, {
    params: {
      id,
      latitude,
      longitude,
      isFromGoogle,
    },
  });
  return res?.data;
};

export const registerUserPhone = async (phone, id) => {
  const res = await publicRequest.post("/home/savePhone", null, {
    params: {
      phone,
      id,
    },
  });
  return res?.data;
};

export const checkIfEmailOrUsernameExists = async data => {
  const res = await publicRequest.post("/home/check1Step", data);
  return res.data;
};

export const fetchUsernameSuggestions = async username => {
  const res = await publicRequest.post("/home/suggest-username", null, {
    params: {
      username,
    },
  });
  return res.data;
};
